import { isEqual } from "lodash"
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux"
import { AppDispatch, RootState } from "../reduxToolkit/store"

export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = (s, eqFn) =>
  useSelector(s, eqFn || isEqual)
